export default __webpack_public_path__ + "static/media/service1.46fa705a.png";